"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LoadIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14A6 6 0 108 2a6 6 0 000 12zm0 2A8 8 0 108 0a8 8 0 000 16z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("radialGradient", {
    id: "paint0_angular_349_892",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(0 8 -8 0 8 8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", null), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.602"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.707",
    stopOpacity: "0.906"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.801",
    stopColor: "#fff",
    stopOpacity: "0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#fff",
    stopOpacity: "0"
  })))))
});
LoadIcon.displayName = 'LoadIcon';
var _default = exports.default = LoadIcon;